// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/index.css' // global css

import '@/utils/directives.js' // 自定义指令
import myUtils from '@/utils/utils.js' // 自定义指令

import '../static/vendor/icon_symbol';

import i18n from './lang/index.js'

Vue.prototype.$myUtils = myUtils;

Vue.use(ElementUI, {
  size: 'medium',
})

/* eslint-disable no-new */
var newVue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
export default newVue



// WEBPACK FOOTER //
// ./src/main.js